//  Third party imports
import { deserialize } from 'cerialize';

export class RActivation {
    @deserialize
    public id: string;
}
